var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"data-testid":_vm.getTestId('admin-image-alignment-page')}},[_c('ImageAlignmentPage',{attrs:{"data-testid":_vm.getTestId('admin-image-alignment-page')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }